import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const portfolioRoutes: RouteRecordRaw[] = [
  {
    path: routes.PORTFOLIO,
    name: 'PORTFOLIO',
    component: () => import('./PortfolioPage.vue'),
    meta: { requiresAuth: true, fullHeight: true },
  },
  {
    path: routes.INVESTMENT_DETAIL,
    name: 'INVESTMENT_DETAIL',
    component: () => import('./InvestmentDetailPage.vue'),
    meta: { requiresAuth: true },
  },
]
